<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  [ngClass]="{ 'xrx-calendar-open': calendarOpen }"
  class="xrx-calendar-wrapper d-flex align-items-end">
  <div class="input-group">
    <div class="input-group-prepend">
      <button
        type="button"
        class="xrx-calendar-btn xrx-btn btn-short btn-secondary xgl-calendar"
        [ngClass]="{ 'is-invalid': isErrorState() }"
        (click)="xrxdp.open(); opened()"></button>
    </div>
    <input
      class="form-control calendar-input"
      [ngClass]="{ 'is-invalid': isErrorState() }"
      [placeholder]="placeholder"
      name="xrxdp"
      (click)="xrxdp.open(); opened()"
      [(ngModel)]="calendarModel"
      ngbDatepicker
      #xrxdp="ngbDatepicker"
      navigation="arrow"
      [maxDate]="maxDate || { year: 9999, month: 12, day: 31 }"
      [minDate]="minDate || { year: 1, month: 1, day: 1 }"
      [readonly]="readonly"
      (dateSelect)="onDateChanged($event)"
      (closed)="closed()"
      positionTarget=".xrx-calendar-btn" />

    @if (isErrorState() && hasAnyError()) {
      <div class="invalid-feedback">
        @if (ngControl.control?.errors?.['customerror']) {
          <div [xdaTranslate]="error"></div>
        }
      </div>
    }
  </div>
</div>
